import React, { useEffect, useState } from "react";
import {
  FiExternalLink,
  FiRefreshCw,
  FiCheckCircle,
  FiXCircle,
  FiLoader,
} from "react-icons/fi";

function App() {
  const [applications, setApplications] = useState([
    {
      id: 1,
      name: "IMAAP",
      url: "https://imaap.beninelectric.com:55682/stafflogin/",
      status: "checking",
      responseTime: "--",
      uptime: "99.98%",
      lastChecked: "--",
    },
    {
      id: 2,
      name: "BEDC BI",
      url: "https://bedc.dashboard.smartpowerbilling.com/login/",
      status: "checking",
      responseTime: "--",
      uptime: "92.11%",
      lastChecked: "--",
    },
    {
      id: 3,
      name: "CRM",
      url: "https://crm.beninelectric.com/login",
      status: "checking",
      responseTime: "--",
      uptime: "98.75%",
      lastChecked: "--",
    },
    {
      id: 4,
      name: "CAMPAIGN DIALER",
      url: "https://dialer.beninelectric.com/login.php",
      status: "checking",
      responseTime: "--",
      uptime: "98.75%",
      lastChecked: "--",
    },
    {
      id: 5,
      name: "Official Website",
      url: "https://beninelectric.com/",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 6,
      name: "3CX",
      url: "https://bedc.3cx.ng/#/people",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 7,
      name: "Contract App",
      url: "https://netapp.beninelectric.com:45790/",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 8,
      name: "New Setup",
      url: "https://newsetup.beninelectric.com:11659/",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 9,
      name: "Bill Adjust",
      url: "https://billadjust.beninelectric.com:55429/login?callbackUrl=%2F",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 10,
      name: "Budget Control",
      url: "https://budgetcontrol.beninelectric.com:11658/",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 11,
      name: "Smart Power",
      url: "https://bedc.smartpowerbilling.com/",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 12,
      name: "SPI",
      url: "https://bedcspi.smartpowerbilling.com/web-login",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 13,
      name: "Adroit",
      url: "http://adroitamr.com/default.aspx",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 14,
      name: "FDM",
      url: "https://ami.beninelectric.com/fdm/#/login",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 15,
      name: "HES",
      url: "https://ami.beninelectric.com/#/login",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 16,
      name: "Attendance App",
      url: "http://attendance.beninelectric.local:8082/",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 17,
      name: "Quickteller Business",
      url: "https://business.quickteller.com/signin",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 18,
      name: "Visitor Analytic Dashboard",
      url: "https://billadjust.beninelectric.com:55428/",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 19,
      name: "CSP Monitor",
      url: "https://vasendpoint.beninelectric.com:11557/login",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
    {
      id: 20,
      name: "Faulty Meter",
      url: "https://faultymdmeter.beninelectric.com:55691/",
      status: "checking",
      responseTime: "--",
      uptime: "99.90%",
      lastChecked: "--",
    },
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case "online":
        return "bg-green-600";
      case "offline":
        return "bg-red-600";
      case "checking":
        return "bg-yellow-500";
      default:
        return "bg-gray-500";
    }
  };

  const checkAppStatus = async (app) => {
    const start = performance.now();

    try {
      const response = await fetch(app.url, {
        mode: "no-cors",
        cache: "no-store",
      });

      // Optional manual override logic: if you want ID 10 (Budget Control) 
      // to forcefully display offline when testing, you can toggle this condition:
      // if (app.id === 10) throw new Error("Forced Offline");

      return {
        status: "online",
        responseTime: `${Math.round(performance.now() - start)} ms`,
        lastChecked: new Date().toLocaleTimeString(),
      };
    } catch (error) {
      return {
        status: "offline",
        responseTime: "--",
        lastChecked: new Date().toLocaleTimeString(),
      };
    }
  };

  const checkSingleApp = async (appId) => {
    setApplications((prev) =>
      prev.map((app) =>
        app.id === appId ? { ...app, status: "checking" } : app
      )
    );

    const app = applications.find((a) => a.id === appId);
    const result = await checkAppStatus(app);

    setApplications((prev) =>
      prev.map((item) =>
        item.id === appId ? { ...item, ...result } : item
      )
    );
  };

  const checkAllApps = async () => {
    const updatedApps = await Promise.all(
      applications.map(async (app) => {
        const result = await checkAppStatus(app);

        return {
          ...app,
          ...result,
        };
      })
    );

    setApplications(updatedApps);
  };

  useEffect(() => {
    checkAllApps();

    const interval = setInterval(() => {
      checkAllApps();
    }, 300000); // 5 minutes

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);

  const totalApps = applications.length;
  const online = applications.filter((app) => app.status === "online").length;
  const offline = applications.filter((app) => app.status === "offline").length;
  const checking = applications.filter((app) => app.status === "checking").length;

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Navbar */}
      <nav className="bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <h1 className="text-white text-2xl font-bold">
            Apps Monitoring Dashboard
          </h1>

          <button
            onClick={checkAllApps}
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-lg text-white"
          >
            <FiRefreshCw />
            Refresh All
          </button>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Statistics */}
        <div className="grid md:grid-cols-4 gap-5 mb-8">
          <StatCard title="Total Apps" value={totalApps} color="text-white" />
          <StatCard title="Online" value={online} color="text-green-400" />
          <StatCard title="Offline" value={offline} color="text-red-400" />
          <StatCard title="Checking" value={checking} color="text-yellow-400" />
        </div>

        {/* Applications */}
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6">
          {applications.map((app) => (
            <div
              key={app.id}
              className="bg-gray-800 rounded-2xl p-6 border border-gray-700 shadow-lg"
            >
              <div className="flex justify-between items-center">
                <h2 className="text-white text-xl font-semibold">
                  {app.name}
                </h2>

                <span
                  className={`px-3 py-1 rounded-full text-white text-xs flex items-center gap-2 ${getStatusColor(
                    app.status
                  )}`}
                >
                  {app.status === "online" && (
                    <>
                      <FiCheckCircle />
                      Online
                    </>
                  )}

                  {app.status === "offline" && (
                    <>
                      <FiXCircle />
                      Offline
                    </>
                  )}

                  {app.status === "checking" && (
                    <>
                      <FiLoader className="animate-spin" />
                      Checking
                    </>
                  )}
                </span>
              </div>

              <div className="mt-5">
                <p className="text-gray-400 text-sm">URL</p>

                <a
                  href={app.url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-indigo-400 break-all"
                >
                  {app.url}
                </a>
              </div>

              <div className="mt-6 space-y-3 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-400">Response Time</span>
                  <span className="text-white">{app.responseTime}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-400">Uptime</span>
                  <span className="text-white">{app.uptime}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-400">Last Checked</span>
                  <span className="text-white">{app.lastChecked}</span>
                </div>
              </div>

              <div className="mt-6 space-y-3">
                <button
                  onClick={() => window.open(app.url, "_blank")}
                  className="w-full flex justify-center items-center gap-2 bg-indigo-600 hover:bg-indigo-700 py-2 rounded-lg text-white"
                >
                  <FiExternalLink />
                  Open Application
                </button>

                <button
                  onClick={() => checkSingleApp(app.id)}
                  className="w-full flex justify-center items-center gap-2 bg-green-600 hover:bg-green-700 py-2 rounded-lg text-white"
                >
                  <FiRefreshCw />
                  Check Status
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const StatCard = ({ title, value, color }) => (
  <div className="bg-gray-800 rounded-xl p-5">
    <h3 className="text-gray-400 text-sm">{title}</h3>
    <p className={`text-3xl font-bold mt-2 ${color}`}>{value}</p>
  </div>
);

export default App;